import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { TransferRequest } from '@/modules/driver/model/driver';
import { namespace } from '@/modules/driver/namespace';

import { updateDriver } from '../actions';

interface IParams {
  driverId: string;
}

let lastRequestId: string | undefined;

const dismissDriver = createAsyncThunk(
  `${namespace}/dismiss-driver`,
  async ({ driverId }: IParams, { dispatch, requestId }) => {
    if (lastRequestId !== undefined) {
      return { isAlreadyExecuted: true };
    }

    lastRequestId = requestId;

    let transferRequest: TransferRequest | undefined;

    try {
      transferRequest = await driverAPI.sendTransferRequest(driverId);

      dispatch(updateDriver({ id: driverId, update: { transferRequest } }));
    } finally {
      lastRequestId = undefined;
    }

    return transferRequest ? { transferRequest } : {};
  },
);

export { dismissDriver };
